import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../services";

// Sign in. One box in the audit register: wordmark, title, underlined fields,
// one outlined button, two text links.

type Mode = "login" | "signup";

export function Login() {
  const navigate = useNavigate();
  const [mode, setMode] = useState<Mode>("login");
  const [email, setEmail] = useState("");
  const [pw, setPw] = useState("");
  const [invite, setInvite] = useState("");
  const [remember, setRemember] = useState(true);
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState<{ text: string; kind: "ok" | "err" | "" }>({ text: "", kind: "" });

  useEffect(() => {
    document.title = "Sign in | Dime Motion";
  }, []);

  async function submit(e: { preventDefault: () => void }) {
    e.preventDefault();
    setBusy(true);
    setMsg({ text: "", kind: "" });
    try {
      if (mode === "login") {
        const r = await api.auth.login(email, pw, remember);
        if (!r.ok) throw new Error(r.error);
        navigate("/", { replace: true });
      } else {
        const r = await api.auth.signup(email, pw, invite || undefined);
        if (!r.ok) throw new Error(r.error);
        navigate("/", { replace: true });
      }
    } catch (err) {
      setMsg({ text: (err as Error).message, kind: "err" });
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="login">
      <div className="box">
        <div className="fbrand">Dime Motion</div>
        <h1 className="stitle">{mode === "login" ? "Sign in" : "Create an account"}</h1>

        <form onSubmit={submit} noValidate>
          {mode === "signup" ? (
            <label className="field">
              <span>Invite code</span>
              <input
                type="text"
                autoComplete="off"
                value={invite}
                onChange={(e) => setInvite(e.target.value)}
              />
            </label>
          ) : null}

          <label className="field">
            <span>Email</span>
            <input
              type="text"
              autoComplete="username"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </label>

          <label className="field">
            <span>Password</span>
            <input
              type="password"
              autoComplete={mode === "login" ? "current-password" : "new-password"}
              required
              value={pw}
              onChange={(e) => setPw(e.target.value)}
            />
          </label>

          {mode === "login" ? (
            <label className="check">
              <input type="checkbox" checked={remember} onChange={(e) => setRemember(e.target.checked)} />
              <span>Keep me signed in</span>
            </label>
          ) : null}

          <button type="submit" className="btn" disabled={busy}>
            {busy ? "Working" : mode === "login" ? "Sign in" : "Create account"}
          </button>

          {msg.text ? (
            msg.kind === "err" ? (
              <div className="note-neg"><p>{msg.text}</p></div>
            ) : (
              <p className="sub-block">{msg.text}</p>
            )
          ) : null}
        </form>

        <div className="links">
          <button
            type="button"
            className="site"
            onClick={() => {
              setMode(mode === "login" ? "signup" : "login");
              setMsg({ text: "", kind: "" });
            }}
          >
            {mode === "login" ? "Create an account with an invite code" : "Sign in instead"}
          </button>
          <button
            type="button"
            className="site"
            onClick={() => setMsg({ text: "Ask an admin for a reset code.", kind: "" })}
          >
            Forgot your password
          </button>
        </div>
      </div>
    </div>
  );
}
